import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllInformacaoFaturamentoUseCase } from "../../../presentation/useCases/read/get_all_informacao_faturamento_use_case";
import { InformacaoFaturamento } from "../../models/informacao_faturamento";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetAllinformacaoFaturamentoUseCase
 */

export class GetAllInformacaoFaturamentoUseCase extends BasePaginatedUseCase<InformacaoFaturamento> implements IGetAllInformacaoFaturamentoUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  getAllinformacaoFaturamento(
    page: number,
    rowsPerPage: number,
    idCentroCusto: number): Promise<void>;

  async getAllinformacaoFaturamento(
    page: number,
    rowsPerPage: number,
    idCentroCusto: number
  ): Promise<void> {
    const response = await this.repository.getInformacaoFaturamentoList(
      page,
      rowsPerPage,
      idCentroCusto
    );
    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }

}

